import { useOpenEditIntegrationTokenModal } from '../../../../../utils/routes/modals/modalsActions'

export const onInstallService = (config, openModal) => {
  openModal('integrations/chat_pro', config, 'Nova integração')

  return
}

export const useReinstallService = (config, openModal) => {
  const openTokenModal = useOpenEditIntegrationTokenModal()

  return ({ id }) => {
    openTokenModal({ ...config, integrationId: id })
  }
}
